import React, { useState, useEffect } from "react";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import {
  ReferralFollowUpNotificationsHeader,
  contraceptiveRSFHeader,
} from "../components/HeaderAttribute";
import toast from "react-hot-toast";
import GridPage from "../components/GridPage";
import { useUserCapability } from "../components/ConstantReducerProvider";
import Loader from "../ReusableComponents/Loader";

const Notifications = ({ closePopup, call }) => {
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const [isLoading, setIsLoading] = useState(false);
  // Contraceptive Renewal Supply Start
  const [bindContraceptiveRenewalData, setBindContraceptiveRenewalData] =
    useState([]);

  const [bindContraceptiveRemarks, setBindContraceptiveRemarks] = useState([]);
  const [
    bindContraceptiveRemarksDiscontinued,
    setBindContraceptiveRemarksDiscontinued,
  ] = useState([]);

  const [contraceptiveNotificationId, setContraceptiveNotificationId] =
    useState("");
  const [contraceptiveDate, setContraceptiveDate] = useState("");
  const [contraceptiveServiceDate, setContraceptiveServiceDate] = useState("");
  const [contraceptiveClientId, setContraceptiveClientId] = useState("");
  const [fpMethod, setFPMethod] = useState("");
  const [serviceId, setServiceId] = useState("");

  const [contraceptiveRemarks, setContraceptiveRemarks] = useState("");
  const [
    contraceptiveRemarksDiscontinued,
    setContraceptiveRemarksDiscontinued,
  ] = useState("");
  const [contraceptiveNextFollowUpDate, setContraceptiveNextFollowUpDate] =
    useState("");

  // Referral Follow Up Start
  const [bindReferralFollowUpData, setBindReferralFollowUpData] = useState([]);
  const [bindReferralFollowUpRemarks, setBindReferralFollowUpRemarks] =
    useState([]);

  const [txnServicesId, setTxnServicesId] = useState("");
  const [referralDate, setReferralDate] = useState("");
  const [referralClientId, setReferralClientId] = useState("");
  const [referralService, setReferralService] = useState("");
  const [referralRemarks, setReferralRemarks] = useState("");

  // Common states
  const [rowIndexData, setRowIndexData] = useState("");
  const [clearNotificationValues, setClearNotificationValues] = useState(false);

  useEffect(() => {
    if (userProfileDatas?.length && call) {
      notificationData(userProfileDatas[0]);
    }
  }, [userProfileDatas, call]);

  const notificationData = async (user) => {
    
    if (!user) return;

    const data = {
      mstOrganizationStructureId: user.MstOrganizationId,
      mstBranchId: user.MstLocationId,
      mstSdpId: user.MstSDPId || 0,
      mstUserId: user.MstUserId,
      mstRoleId: user.MstRoleId,
    };

    try {
      // ✅ Call both APIs in parallel
      const [referralRes, contraceptiveRes] = await Promise.all([
        BindPostAPI([data], "NotificationAPI/BindReferralFollowUpNotification"),
        BindPostAPI([data], "NotificationAPI/BindContraceptiveNotification"),
      ]);

      console.log("Referral Response:", referralRes.data);
      console.log("Contraceptive Response:", contraceptiveRes.data);

      // ✅ Set states safely
      setBindContraceptiveRenewalData(
        contraceptiveRes.data?.Table ?? contraceptiveRes.data?.Table1 ?? []
      );
      setBindReferralFollowUpData(
        referralRes.data?.Table ?? referralRes.data?.Table1 ?? []
      );
    } catch (error) {
      console.error("Error fetching notification data:", error);
    }
  };

  const handleNotificationData = (updatedData) => {
    updatedData.forEach((item) => {
      setRowIndexData(item.RowIndex);
      setTxnServicesId(item.TxnServicesId);
      setReferralDate(item.Date);
      setReferralClientId(item.ClientID);
      setReferralService(item.ReferralService);
      setReferralRemarks(item.Remarks);
    });
  };

  useEffect(() => {
    if (!call) return;
    const fetchRemarksDropdowns = async () => {
      try {
        setIsLoading(true);
        const [remarksResponse, discontinuedResponse, referralResponse] =
          await Promise.all([
            BindAPI("NotificationAPI/BindContraceptiveRemarks"),
            BindAPI("NotificationAPI/BindContraceptiveDiscontinuedRemarks"),
            BindAPI("NotificationAPI/BindReferralFollowUpRemarks"),
          ]);

        setBindContraceptiveRemarks(
          remarksResponse.data?.Table?.map((m) => ({
            value: m.MstContraceptiveRemarksId,
            label: m.Remarks_en,
          })) ?? []
        );

        setBindContraceptiveRemarksDiscontinued(
          discontinuedResponse.data?.Table?.map((m) => ({
            value: m.MstContraceptiveDiscontinuedRemarksId,
            label: m.Remarks_en,
          })) ?? []
        );

        setBindReferralFollowUpRemarks(
          referralResponse.data?.Table?.map((m) => ({
            value: m.MstReferralFollowUpRemarksId,
            label: m.Remarks_en,
          })) ?? []
        );
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching remarks dropdowns:", error);
      }
    };

    fetchRemarksDropdowns();
  }, [call]);

  const handleContraceptiveNotificationData = (updatedData) => {
    updatedData.forEach((item) => {
      setRowIndexData(item.RowIndex);
      setContraceptiveNotificationId(item.TxnContraceptiveNotificationId);
      setContraceptiveDate(item.Date);
      setContraceptiveServiceDate(item.ServiceDate);
      setContraceptiveClientId(item.ClientID);
      setFPMethod(item.FPMethod);
      setServiceId(item.TxnServicesId);

      setContraceptiveRemarks(item.Remarks);
      setContraceptiveRemarksDiscontinued(item.Remarks2);
      setContraceptiveNextFollowUpDate(item.NextFollowUpDate);
    });
  };

  const handleClearNotificationValues = (data) => {
    data && setClearNotificationValues(false);
  };

  const cancel = () => {
    setClearNotificationValues(true);
    setRowIndexData("");
    setContraceptiveNotificationId("");
    setContraceptiveDate("");
    setContraceptiveServiceDate("");
    setContraceptiveClientId("");
    setFPMethod("");
    setServiceId("");
    setIsLoading(false);
    setContraceptiveRemarks("");
    setContraceptiveRemarksDiscontinued("");
    setContraceptiveNextFollowUpDate("");

    setTxnServicesId("");
    setReferralDate("");
    setReferralClientId("");
    setReferralService("");
    setReferralRemarks("");

    notificationData(userProfileDatas[0]);
  };

  const HandleSubmit = async (rowIndex) => {
     setIsLoading(true);
    if (rowIndex == rowIndexData) {
      const data = {
        txnContraceptiveNotificationId: contraceptiveNotificationId,
        date: contraceptiveDate,
        serviceDate: contraceptiveServiceDate,
        clientID: contraceptiveClientId,
        remarks: contraceptiveRemarks,
        remarksDiscontinued: contraceptiveRemarksDiscontinued || 0,
        fpMethod: fpMethod,
        txnServicesId: serviceId,
        nextFollowUp: contraceptiveNextFollowUpDate || null,
        createdBy: sessionStorage.getItem("createdBy"),
        flag: 1,
      };

      const response = await IUDAPI(
        [data],
        "NotificationAPI/IUDContraceptiveNotification"
      );

      if (response.data.Table[0].Result == "M") {
        toast.success("Contraceptive Notification saved successfully 👍");
        setTimeout(cancel, 3000);
      } else {
        toast.error("Contraceptive Notification insert failed 👎");
        setTimeout(cancel, 3000);
      }
    } else {
      toast.error("Please fill only one row 👎");
       setIsLoading(false);
      setTimeout(cancel, 3000);
    }
  };

  const HandleSubmit1 = async (rowIndex) => {
     setIsLoading(true);
    if (rowIndex == rowIndexData) {
      const data = {
        txnServicesId: txnServicesId,
        date: referralDate,
        clientID: referralClientId,
        remarks: referralRemarks,
        createdBy: sessionStorage.getItem("createdBy"),
        flag: 1,
      };

      const response = await IUDAPI(
        [data],
        "NotificationAPI/IUDReferralFollowUpNotification"
      );

      if (response.data.Table[0].Result == "M") {
        toast.success("Referral Follow Up saved successfully 👍");
        setTimeout(cancel, 3000);
      } else {
        toast.error("Referral Follow Up insert failed 👎");
        setTimeout(cancel, 3000);
      }
    } else {
      toast.error("Please fill only one row 👎");
       setIsLoading(false);
      setTimeout(cancel, 3000);
    }
  };

  return (
    <div className="w-full">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      <div className="">
        <div className="block mb-2 px-2 text-base capitalize font-bold text-neutral-700 ">
          Notifications
        </div>
        <div className="px-2 ">
          <hr className="h-px my-2 bg-red-600 border-0" />
        </div>

        <form className="overflow-y-scroll px-5 max-h-[72vh]">
          <GridPage
            title="Contraceptive Renewal Supply Follow Up"
            header={contraceptiveRSFHeader}
            records={bindContraceptiveRenewalData}
            bindContraceptiveRemarks={bindContraceptiveRemarks}
            bindDiscontinuedRemarks={bindContraceptiveRemarksDiscontinued}
            onContraceptiveNotificationDatas={
              handleContraceptiveNotificationData
            }
            onNotificationSave={HandleSubmit}
            onNotificationClear={clearNotificationValues}
            onNotificationClearFalse={handleClearNotificationValues}
            addView={true}
          />
        </form>

        <div className="px-2 ">
          <hr className="h-px my-2 bg-red-600 border-0" />
        </div>

        <form className="overflow-y-scroll px-5 max-h-[72vh]">
          <GridPage
            title="Referral Follow Up"
            header={ReferralFollowUpNotificationsHeader}
            records={bindReferralFollowUpData}
            onReferralFollowUpNotificationDatas={handleNotificationData}
            bindReferralFollowUpRemarks={bindReferralFollowUpRemarks}
            onNotificationSave={HandleSubmit1}
            onNotificationClear={clearNotificationValues}
            onNotificationClearFalse={handleClearNotificationValues}
            addView={true}
          />
        </form>
      </div>
    </div>
  );
};

export default Notifications;
